import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import api from "../../../../../../api/api";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../../state/global/slice";
import TabContent from "./TabContent";

function MyCourses() {
  const { token } = useAuth();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("all-courses");

  // Define the fetch function
  const fetchCourses = async () => {
    const response = await api.get(`courses/student/my-courses/`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Token ${token}`,
      },
    });

    if (Number(response.data.status) === 200) {
      return response.data.data;
    } else {
      throw new Error("Error fetching courses");
    }
  };

  // Use the useQuery hook
  const { data: courses, isError, isLoading, error } = useQuery({
    queryKey: ["my_courses"],
    queryFn: fetchCourses,
  });

  // v5: moved from onSuccess (removed for queries in v5) — update global state when data arrives
  useEffect(() => {
    if (courses !== undefined) {
      dispatch(updateGlobalState({ key: "my_courses", value: courses }));
    }
  }, [courses]);

  // Calculate all_courses manually
  const allCourses = [
    ...(courses?.active_courses || []),
    ...(courses?.requested_courses || []),
    ...(courses?.completed_courses || []),
    ...(courses?.expired_courses || []),
  ];

  const totalLength = allCourses.length;

  useEffect(() => {
    dispatch(
      updateGlobalState({ key: "my_courses_length", value: totalLength })
    );
  }, [totalLength]);

  return (
    <div className="StudentCourseCard-section" id="StudentCourseCard-section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="StudentCourseCard-wrapper">
              <div className="view-lessons-section">
                <div className="view-lessons-wrapper">
                  <div className="view-lessons-btn-container StudentCourseCard-lessons-tab-container">
                    {isLoading ? (
                      <>Loading</>
                    ) : (
                      courses &&
                      ["all_courses", ...Object.keys(courses)].map(
                        (courseCategory, index) => {
                          const courseCount =
                            courseCategory === "all_courses"
                              ? totalLength
                              : courses[courseCategory].length;
                          const tabKey = courseCategory === "all_courses"
                            ? "all-courses"
                            : courseCategory.replace(/_/g, "-");
                          return (
                            <button
                              key={index}
                              className={`tab-button ${
                                activeTab === tabKey ? "active" : ""
                              }`}
                              onClick={() => setActiveTab(tabKey)}
                            >
                              {`${
                                courseCategory === "all_courses"
                                  ? "All Courses"
                                  : courseCategory.replace(/_/g, " ")
                              } (${courseCount})`}
                            </button>
                          );
                        }
                      )
                    )}
                  </div>
                  {activeTab === "all-courses" && (
                    <TabContent
                      courses={allCourses}
                      isLoading={isLoading}
                    />
                  )}
                  {activeTab === "active-courses" && (
                    <TabContent
                      courses={courses?.active_courses}
                      isLoading={isLoading}
                    />
                  )}
                  {activeTab === "completed-courses" && (
                    <TabContent
                      courses={courses?.completed_courses}
                      isLoading={isLoading}
                    />
                  )}
                  {activeTab === "requested-courses" && (
                    <TabContent
                      courses={courses?.requested_courses}
                      isLoading={isLoading}
                    />
                  )}
                  {activeTab === "expired-courses" && (
                    <TabContent
                      courses={courses?.expired_courses}
                      isLoading={isLoading}
                    />
                  )}
                  {activeTab === "favourite-courses" && (
                    <TabContent isLoading={isLoading} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyCourses;